import { castArray, every, map, values } from 'lodash/fp'
import { voivodeships } from '../components/Units/utils'

const emailRegex = /^[-\w.!#$%&'*+=?`(){|}~^-]+@([-\w]+\.)+[a-z]+$/i
const upperRegex = /(?=[A-Z])/
const lowerRegex = /(?=[a-z])/
const numberRegex = /(?=[0-9])/
const specialCharRegex = /(?=[!@#$%^&*(),.?":{}|<>])/
const postcodeRegex = /[0-9]{2}-[0-9]{3}/
const phoneNumber = /[0-9]{9}/
const peselRegex = /[0-9]{11}/
const rspoRegex = /^\d+$/

// min 6 chars, at least one lower,one uppercase, one dig and one special char
// eslint-disable-next-line
const passwordRegex = /^.*(?=.{6,120})(?!.*\s)(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\!\@\#\$\%\^\&\*\(\)\-\=\¡\£\_\+\`\~\.\,\<\>\/\?\;\:\'\"\\\|\[\]\{\}]).*$/

export const validationMessages = {
  invalidEmail: 'Niepoprawny adres email',
  invalidPostcode: 'Niepoprawny kod pocztowy ( _ _ - _ _ _ )',
  invalidVoivodeship: 'Niepoprawne województwo',
  noNumber: 'brak możliwości wprowadzania innych znaków niż cyfry',
  required: 'To pole jest obowiązkowe',
  tooShort: 'Za mało znaków',
  invalidPhoneNumber: 'Niepoprawny numer telefonu',
  invalidPesel: 'Niepoprawny numer pesel',
  invalidPassword:
    // eslint-disable-next-line max-len
    'Hasło musi mieć min 6 znaków w tym jedną małą, jedną dużą literę, jedną cyfrę i jeden znak specjalny',
  notSame: 'Wartości muszą być takie same',
  invalidRSPO: 'Niepoprawny indentyfikator RSPO',
}

export const required = (value) =>
  value === undefined ||
  value === null ||
  value === '' ||
  (Array.isArray(value) && value.length === 0)
    ? 'required'
    : undefined

export const composeValidators = (...validators) => (value) =>
  validators.reduce((error, validator) => error || validator(value), undefined)

export const mapValidators = (...validators) => (value) =>
  validators.map((validator) => validator(value))

export const validateEmail = (value) =>
  !emailRegex.test(value) ? 'invalidEmail' : undefined

export const validateLength = (minLength) => (value) =>
  !value || value.length < minLength ? 'tooShort' : undefined

export const validatePassword = (value) =>
  !passwordRegex.test(value) ? 'invalidPassword' : undefined

export const upperLetter = (value) =>
  !upperRegex.test(value) ? 'noUppercase' : undefined

export const lowerLetter = (value) =>
  !lowerRegex.test(value) ? 'noLowercase' : undefined

export const number = (value) =>
  !numberRegex.test(value) ? 'noNumber' : undefined

export const specialChar = (value) =>
  !specialCharRegex.test(value) ? 'noSpecialChar' : undefined

export const postCode = (value) =>
  !postcodeRegex.test(value) ? 'invalidPostcode' : undefined

export const voivodeshipValidation = (value) =>
  !voivodeships.some((obj) => obj.label === value)
    ? 'invalidVoivodeship'
    : undefined

export const validateEquality = (fields) => (allValues) => {
  const errors = {}
  const allValuesArray = values(allValues)
  if (every((val) => val === allValuesArray[0], allValuesArray)) {
    return
  } else {
    map((field) => (errors[field] = 'notSame'), castArray(fields))
  }
  return errors
}

export const validatePhoneNumber = (value) =>
  !phoneNumber.test(value) ? 'invalidPhoneNumber' : undefined

export const validateEmailArray = (value) => {
  const emailArray = value.split(',')
  let isEmailInvalid = false
  emailArray.forEach((email) => {
    return !emailRegex.test(email.trim()) && (isEmailInvalid = true)
  })
  return isEmailInvalid ? 'invalidEmail' : undefined
}

export const validatePesel = (value) =>
  !peselRegex.test(value) ? 'invalidPesel' : undefined

export const validateRSPO = (value) =>
  !rspoRegex.test(value) ? 'invalidRSPO' : undefined
